module.exports = __webpack_public_path__ + "static/img/crm-swiper-3.11fda475.png";